var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_2195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0895 5.93032C15.0895 5.56365 14.7895 5.26365 14.4228 5.26365H9.75617C9.3895 5.26365 9.0895 5.56365 9.0895 5.93032C9.0895 6.29699 9.3895 6.59699 9.75617 6.59699H14.4228C14.7895 6.59699 15.0895 6.29699 15.0895 5.93032ZM9.0895 11.2637C9.0895 11.6303 9.3895 11.9303 9.75617 11.9303H14.4228C14.7895 11.9303 15.0895 11.6303 15.0895 11.2637C15.0895 10.897 14.7895 10.597 14.4228 10.597H9.75617C9.3895 10.597 9.0895 10.897 9.0895 11.2637ZM7.40283 3.68365C7.66283 3.94365 7.66283 4.36365 7.40283 4.62365L4.58283 7.45699C4.32283 7.71699 3.90283 7.71699 3.63617 7.45699L2.22283 6.03699C1.96283 5.77699 1.96283 5.35699 2.22283 5.09699C2.48283 4.83699 2.90283 4.83699 3.16283 5.09699L4.1095 6.04365L6.4695 3.68365C6.72283 3.43032 7.1495 3.43032 7.40283 3.68365ZM7.4095 9.02365C7.6695 9.28365 7.6695 9.70365 7.4095 9.96365L4.5895 12.797C4.3295 13.057 3.9095 13.057 3.64283 12.797L2.22283 11.3703C1.96283 11.1103 1.96283 10.6903 2.22283 10.4303C2.48283 10.1703 2.90283 10.1703 3.16283 10.4303L4.1095 11.377L6.4695 9.01699C6.72283 8.76365 7.1495 8.76365 7.4095 9.02365Z",
    fill: "#3A4B68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_2195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.422852 0.597168)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/Checklist.7998e1c61c62ee609f770378dbe87292.svg";
export { ForwardRef as ReactComponent };